
$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }
    });
  });

  $(function () {
  var $slider = $('#slider');
  var $slides = $slider.find('.swiper-slide');

  var mainSwiper = new Swiper('#slider', {
    // 既存設定
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 1000,
    centeredSlides: true,
    allowTouchMove: true,
    // autoplay: { delay: 2000 },

    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 10
      }
    },

    // ▼ 追加：タブ風 pagination
    pagination: {
      el: '#slider .swiper-pagination',
      clickable: true,

      renderBullet: function (index, className) {
        // loop:true 対策（実スライド基準で取得）
        var realIndex = index % $slides.length;
        var title = $slides.eq(realIndex).data('title');

        return (
          '<button type="button" class="' + className + '">' +
            title +
          '</button>'
        );
      }
    }
  });


  var reviewSwiper = new Swiper('#slider2', {
    // 既存設定
    loop: false,
    spaceBetween: 20,
    speed: 1000,
    centeredSlides: false,
    allowTouchMove: false,
    // autoplay: { delay: 2000 },

    breakpoints: {
      768: {
        slidesPerView: 1,
        loopedSlides: 2,
        initialSlide: 0,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
        // allowTouchMove: true,
      }
    }
  });
});


  $(window).resize(function(){
      mainSwiper.autoplay.paused = false;
      mainSwiper.autoplay.start();
  });

  $('.sp_header_menu_btn').click(function(){
    $('header').toggleClass('menu_open');
  });
  $('header a').click(function(){
    $('header').removeClass('menu_open');
  });

});
